exports.fontWeightRegular = 400
exports.fontWeightMedium = 500
exports.fontWeightSemibold = 600
exports.fontWeightBold = 700
